module.exports = __webpack_public_path__ + "static/media/plan_confirmation.ab05e0f5.svg";